import adminAnalyticsSaga from "./admin_analytics_saga";
import groupWiseAccountsCountSaga from "./group_wise_analytics_saga";

export default [adminAnalyticsSaga, groupWiseAccountsCountSaga];
